const firebaseConfig = {
    apiKey: "AIzaSyDOsADQAxSmIGot2Z0QPi1w2wcujoan87c",
    authDomain: "smart-travels-aa8f2.firebaseapp.com",
    projectId: "smart-travels-aa8f2",
    storageBucket: "smart-travels-aa8f2.appspot.com",
    messagingSenderId: "560763355563",
    appId: "1:560763355563:web:18382e08fdbb682c2552ee"
};

export default firebaseConfig;